import React from 'react';
import SkeletonStyles from './Skeletons.module.css';

const ButtonSkeleton = () => {
	return <div className={[ SkeletonStyles.button, SkeletonStyles.skeleton ].join(' ')} />;
};

export default ButtonSkeleton;
